import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TourService, TOUR_WELCOME_MODAL_ID } from '../../services/tour/tour.service';

@Component({
  selector: 'app-tour-welcome-modal',
  imports: [CommonModule],
  templateUrl: './tour-welcome-modal.component.html',
})
export class TourWelcomeModalComponent {
  private readonly tour = inject(TourService);
  modalId = TOUR_WELCOME_MODAL_ID;

  onStart(): void {
    this.tour.startTour();
  }

  onSkip(): void {
    this.tour.skipTour();
  }
}
